/** Formatadores de valores da Rede Proto (pt-BR). */

/** Valor exibido quando o backend retorna `null` (sem OS/meta/credenciada). */
export const EMPTY_VALUE = '—';

type Nullable = number | null | undefined;

export const formatInt = (value: Nullable): string =>
  value == null
    ? EMPTY_VALUE
    : value.toLocaleString('pt-BR', { maximumFractionDigits: 0 });

/** Percentual já na escala 0–100 (ex.: 83.4 → "83,4%"). */
export const formatPct = (value: Nullable, digits = 1): string =>
  value == null
    ? EMPTY_VALUE
    : `${value.toLocaleString('pt-BR', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      })}%`;

/** Fração 0–1 convertida em percentual (ex.: 0.8195 → "82,0%"). */
export const formatRatioPct = (value: Nullable, digits = 1): string =>
  value == null ? EMPTY_VALUE : formatPct(value * 100, digits);

/** CSAT na escala 0–5 (ex.: 3.85 → "3,85"). */
export const formatCsat = (value: Nullable): string =>
  value == null
    ? EMPTY_VALUE
    : value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

/** Preço em reais (ex.: 350 → "R$ 350,00"). */
export const formatCurrency = (value: Nullable): string =>
  value == null
    ? EMPTY_VALUE
    : value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

/** Trunca um texto longo com reticências (nomes de tipologia/edital). */
export const truncate = (
  value: string | null | undefined,
  max = 32
): string => {
  if (!value) return EMPTY_VALUE;
  return value.length > max ? `${value.slice(0, max - 1)}…` : value;
};
